import { ApiBlueprint } from '@backstage/frontend-plugin-api';
import {
  convertLegacyPlugin,
  convertLegacyPageExtension,
} from '@backstage/core-compat-api';
import {
  costInsightsApiRef,
  costInsightsPlugin,
  CostInsightsPage,
} from '@backstage-community/plugin-cost-insights';
import { TallenceCostInsightsClient } from './TallenceCostInsightsClient';

// cost-insights ist noch nicht aufs neue Frontend-System migriert: sein
// /alpha-Bundle ruft das in Backstage 1.52 entfernte NavItemBlueprint (daher
// ist das Paket in app-config aus der Package-Discovery ausgeschlossen).
// Statt die Seite einzeln hand zu verdrahten (das laesst die internen Routes/
// RouteRefs der Seite fehlen) bruecken wir das komplette Legacy-Plugin sauber
// ueber core-compat-api ins neue System. Unser Mock-Client erfuellt
// costInsightsApiRef.
const costInsightsApi = ApiBlueprint.make({
  name: 'cost-insights',
  params: defineParams =>
    defineParams({
      api: costInsightsApiRef,
      deps: {},
      factory: () => new TallenceCostInsightsClient(),
    }),
});

export const costInsights = convertLegacyPlugin(costInsightsPlugin, {
  extensions: [
    convertLegacyPageExtension(CostInsightsPage, { path: '/cost-insights' }),
    costInsightsApi,
  ],
});
